import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '../../design/css';
import OrderButton from './orderButton';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { orderStatus as statusConstants } from '../../utils/constant';

const OrderAction = ({
  button,
  orderStatus,
  status,
  onStatusChange,
  isOrderValidating,
  actionChanged,
  isOrderUpdated
}) => {
  const localizedString = useLocalizedStringsContext();

  const {
    ORDERS: { save }
  } = localizedString;
  const {
    contractSend,
    submitted,
    SendBacktoAccountManager,
    SendBacktoPreSalesEngineer
  } = statusConstants;

  const IsButtonVisible = [
    statusConstants.pendingValidation,
    statusConstants.SendBacktoAccountManager,
    statusConstants.contractSend,
    statusConstants.contractSigned
  ].includes(orderStatus);

  const isSendToAccountManager = [statusConstants.pendingValidation].includes(
    orderStatus
  );

  const isSendContractEligible = [
    statusConstants.SendBacktoAccountManager,
    statusConstants.contractSend
  ].includes(orderStatus);

  const isSubmitOrderAllowed = [statusConstants.contractSigned].includes(
    orderStatus
  );

  const isContractSendBackToSalesRep = [statusConstants.contractSend].includes(
    orderStatus
  );

  const getButtonLabel = () => {
    if (actionChanged) {
      switch (status) {
        case contractSend:
          return 'Send Contract';
        case submitted:
          return 'Submit';
        case SendBacktoAccountManager:
          return 'Send to Account Manager';
        case SendBacktoPreSalesEngineer:
          return 'Send Back to Pre-Sales Engineer';
        default:
          return save;
      }
    }
    return save;
  };

  return (
    <>
      <div
        className="frg-select-container color-light"
        style={{
          position: 'relative',
          width: '100%',
          height: '50px',
          marginTop: '1.5rem'
        }}
      >
        <select style={{ fontSize: '1rem' }} onChange={onStatusChange}>
          <option selected disabled>
            {'Select an Option'}
          </option>
          {isSendToAccountManager && (
            <option value={SendBacktoAccountManager}>
              Send to Account Manager
            </option>
          )}
          {isSendContractEligible && (
            <option value={contractSend}>Send Contract</option>
          )}
          {isContractSendBackToSalesRep && (
            <option value={SendBacktoPreSalesEngineer}>
              Send Back to Pre-Sales Engineer
            </option>
          )}
          {isSubmitOrderAllowed && (
            <option value={submitted}>Submit Order</option>
          )}
        </select>
      </div>

      {IsButtonVisible && (
        <Box
          display="flex"
          justifyContent="space-evenly"
          flexDirection="row"
          width={100}
          mdWidth={100}
          pr={16}
          pl={16}
          pt={28}
          pb={24}
        >
          <OrderButton
            button={{ ...button, label: getButtonLabel() }}
            isOrderValidating={isOrderValidating}
            isDisabled={isOrderUpdated}
            actionChanged={actionChanged}
          />
        </Box>
      )}
    </>
  );
};

OrderAction.propTypes = {
  button: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    variant: PropTypes.string
  }).isRequired,
  orderStatus: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  isOrderValidating: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isDisabled,
  actionChanged: PropTypes.bool.isRequired
};

export default OrderAction;
